export default __webpack_public_path__ + "static/media/14.d355c537.png";